import { Box, Card, DialogContent } from '@mui/material'
import type { EventDTO } from '~entities/index'
import { useImageLoader } from '~sharedLib'
import { MainModalContainer, type ModalProps, Typography } from '~sharedUI'
import { EventDateCard } from '../molecules/eventDateCard'
import { EventDetails } from '../molecules/eventDetails'
import { SourceQRCodeCard } from '../molecules/sourceQRCodeCard'

type EventDetailsModalProps = {
	info: EventDTO | undefined
	isLinkOpen: boolean
	setIsLinkOpen: (v: boolean) => void
	setLink: (link: string | undefined) => void
} & ModalProps

export const EventDetailsModal = (
	{ open, onClose, info, isLinkOpen, setIsLinkOpen, setLink, ...props }: EventDetailsModalProps
) => {
	const isLoaded = useImageLoader(info?.picture)

	return (
		<>
			<MainModalContainer
				{...props}
				onClose={onClose}
				open={open && !isLinkOpen}
				fullWidth
			>
				<Card sx={{ flexShrink: 0, maxWidth: 1024 }}>
					{isLoaded && info?.picture && (
						<Box
							sx={{
								height: '320px',
								backgroundImage: `url(${info.picture})`,
								backgroundSize: 'cover',
								backgroundPosition: 'top'
							}}
						/>
					)}
					<DialogContent sx={{ padding: '24px 32px 32px', gap: '24px' }}>
						<Box display={'flex'} flexDirection={'column'} gap={'16px'}>
							<Typography fontSize='xl' lineHeight={'52px'} fontWeight='bold'>{info?.name}</Typography>
							<EventDateCard date={info?.date} />
						</Box>
						<EventDetails
							details={info?.detail}
							setIsLinkOpen={setIsLinkOpen}
							setLink={setLink}
						/>
					</DialogContent>
				</Card>
			</MainModalContainer>
			{open && !isLinkOpen && <SourceQRCodeCard link={info?.url} />}
		</>
	)
}
